'use client';

import { useEffect } from 'react';
import { useFbtContext } from './fbt-context-provider';
import { CartResponse } from 'services/cart/types';
import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import { areEqualArrays } from 'components/price-and-fitment-context-entry/utils';

interface FbtCartContextEntryProps {
  cartDetails: CartResponse;
  listenerKey: string;
}

const FbtCartContextEntry = ({
  cartDetails: cartDetailsProps,
  listenerKey
}: FbtCartContextEntryProps) => {
  const { cartDetails, setCartDetails } = useFbtContext();

  useEffect(() => {
    const cartDetailsPropsArray = Object.keys(cartDetailsProps ?? {});
    const cartDetailsContextArray = Object.keys(cartDetails ?? {});
    if (
      !isEmpty(cartDetailsPropsArray) &&
      !areEqualArrays(cartDetailsPropsArray, cartDetailsContextArray)
    ) {
      setCartDetails(cartDetailsProps);
    }
  }, [cartDetailsProps, listenerKey, cartDetails, setCartDetails]);

  return null;
};

export default FbtCartContextEntry;
